module.exports = __webpack_public_path__ + "img/ga.701928cb.svg";